// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zh6G2","content":"styles_content__3RAMq"};